import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { SabloaneService } from '../sabloane.service';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-edit-sabloane',
    templateUrl: './edit-sabloane.component.html',
    styleUrls: ['./edit-sabloane.component.scss'],
})
export class EditSabloaneComponent implements OnInit {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    editorConfig!: AngularEditorConfig;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        content: new FormControl(this.data.content, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditSabloaneComponent>,
        private sabloaneService: SabloaneService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }
    ngOnInit(): void {
        this.editorConfig = initializeEditor();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.sabloaneService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const updatedSablonData = {
            name: this.form.get('name')?.value,
            content: this.form.get('content')?.value,
            id: this.data.id,
        };

        this.sabloaneService
            .updateSablon(updatedSablonData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }
}
